import { z } from 'zod';
/**
 * Integraciok szerzodese.
 *
 * Ez a projekt masodik fo indoka: a ceges rendszerek tudjanak beszelni a
 * chattel. A felulet szandekosan a Slackre hasonlit - a meglevo tudas es a
 * meglevo integracios kod igy nagyreszt athozhato.
 */
// ─── Jogosultsagok ────────────────────────────────────────────────────────────
/**
 * Bot-tokenek jogosultsagai.
 *
 * Szandekosan aprok: egy uzenetkuldo integracionak `chat:write` eleg, es akkor
 * sem tud csatornat archivalni vagy felhasznalot listazni, ha a tokenje
 * kiszivarog. A "mindent szabad" token nem opcio.
 */
export const apiScopes = [
    'chat:write',
    'channels:read',
    'channels:history',
    'channels:manage',
    'users:read',
    'reactions:write',
    'files:write',
    /** Telefonhivas inditasa egy kolléga neveben (ProjectFlow, `POST /api/calls`). */
    'calls:write',
    /** Emlekezteto beallitasa (szemelyes MCP-token, versenyaudit M6). */
    'reminders:write',
    /**
     * Kozvetlen uzenetek (DM) elerese - CSAK szemelyes tokenen, kulon pipaval.
     * Enelkul az MI a DM-eket nem latja, es nem is irhat beloluk.
     */
    'dm:access',
];
export const apiScopeSchema = z.enum(apiScopes);
export const SCOPE_LABELS = {
    'chat:write': 'Üzenetküldés és saját üzenet szerkesztése',
    'channels:read': 'Csatornalista olvasása',
    'channels:history': 'Csatorna-előzmény olvasása',
    'channels:manage': 'Csatorna létrehozása, meghívás',
    'users:read': 'Felhasználólista olvasása',
    'reactions:write': 'Reakció hozzáadása',
    'files:write': 'Fájl feltöltése',
    'calls:write': 'Telefonhívás indítása egy kolléga nevében',
    'reminders:write': 'Emlékeztető beállítása',
    'dm:access': 'Közvetlen üzenetek (DM) elérése',
};
/**
 * SZEMELYES MCP-TOKEN (versenyaudit M6) - a kolléga a sajat neveben adja ki.
 *
 * Az olvasas mindig benne van; az iras es a DM kulon dontes. A token SOSEM
 * kaphat tobbet, mint amit a gazdaja maga tehet - a jog a felhasznaloe.
 */
export const PERSONAL_READ_SCOPES = ['channels:read', 'channels:history', 'users:read'];
export const PERSONAL_WRITE_SCOPES = [
    'chat:write',
    'reactions:write',
    'reminders:write',
];
export const createPersonalTokenInput = z.object({
    name: z.string().trim().min(1).max(80),
    /** Uzenet, reakcio, emlekezteto. */
    write: z.boolean().default(false),
    /** Kozvetlen uzenetek elerese - alapbol NEM. */
    dms: z.boolean().default(false),
    expiresInDays: z.number().int().min(1).max(365).optional(),
});
// ─── Tokenek ──────────────────────────────────────────────────────────────────
/** `user`: szemelyes token az MCP-szerverhez (M6) - a gazdaja neveben. */
export const apiTokenKindSchema = z.enum(['bot', 'webhook', 'user']);
/**
 * A token elotagja arulja el a fajtajat.
 *
 * Ettol a szerver egy pillantasbol tudja, hogy session-JWT-t vagy API-tokent
 * kapott, es a titkoskereso eszkozok is felismerik a szivargast a naplokban.
 */
export const TOKEN_PREFIX = { bot: 'avsb_', webhook: 'avsw_', user: 'avsu_' };
export const apiTokenSchema = z.object({
    id: z.string(),
    kind: apiTokenKindSchema,
    name: z.string(),
    /** Felismeresi segedlet - a titok NEM jon vissza a letrehozas utan. */
    prefix: z.string(),
    botUserId: z.string().nullable(),
    botName: z.string().nullable(),
    channelId: z.string().nullable(),
    channelName: z.string().nullable(),
    scopes: z.array(apiScopeSchema),
    /** Hivasinditas minden cegre, ahol a ProjectFlow be van kapcsolva (csak szuperadmin allitja). */
    allTeamsCalls: z.boolean(),
    /** A token cege - a szuperadmin listajaban latszik, kie. */
    teamId: z.string(),
    createdAt: z.string(),
    lastUsedAt: z.string().nullable(),
    expiresAt: z.string().nullable(),
    revokedAt: z.string().nullable(),
});
export const updateTokenInput = z.object({ allTeamsCalls: z.boolean() });
export const createTokenInput = z
    .object({
    kind: apiTokenKindSchema,
    name: z.string().trim().min(1).max(80),
    /** Webhooknal kotelezo: melyik csatornaba irhat. */
    channelId: z.string().optional(),
    /** Botnal: a megjeleno nev. Uj bot-felhasznalo jon letre vele. */
    botDisplayName: z.string().trim().min(1).max(80).optional(),
    scopes: z.array(apiScopeSchema).default([]),
    expiresInDays: z.number().int().min(1).max(3650).optional(),
})
    .refine((value) => value.kind !== 'webhook' || Boolean(value.channelId), {
    message: 'Webhook tokenhez csatornát kell valasztani.',
    path: ['channelId'],
})
    .refine((value) => value.kind !== 'bot' || value.scopes.length > 0, {
    message: 'A bot tokenhez legalább egy jogosultság kell.',
    path: ['scopes'],
});
// ─── Bejovo webhook ───────────────────────────────────────────────────────────
/**
 * A bejovo webhook torzse.
 *
 * A `text` az egyetlen kotelezo mezo - ez a "10 sor koddal kuldj uzenetet"
 * igeret. A tobbi diszites.
 */
export const incomingWebhookInput = z.object({
    text: z.string().min(1).max(12_000),
    /** Felulirja a bot megjeleno nevet erre az egy uzenetre. */
    username: z.string().trim().max(80).optional(),
    emoji: z.string().trim().max(16).optional(),
    /** Szalba valasz: a szulo uzenet azonositoja. */
    threadId: z.string().optional(),
    /** Egyszeru gombok az uzenet alatt. */
    actions: z
        .array(z.object({
        id: z.string().min(1).max(64),
        label: z.string().min(1).max(60),
        style: z.enum(['default', 'primary', 'danger']).default('default'),
        /** Ha ki van toltve, a gomb linkkent viselkedik. */
        url: z.string().url().optional(),
    }))
        .max(5)
        .optional(),
});
/** Az uzenet `meta.actions` mezojenek alakja - ebbol rajzol a kliens gombot. */
export const messageActionSchema = z.object({
    id: z.string(),
    label: z.string(),
    style: z.enum(['default', 'primary', 'danger']),
    url: z.string().optional(),
});
// ─── Slash parancsok ──────────────────────────────────────────────────────────
export const slashCommandSchema = z.object({
    id: z.string(),
    command: z.string(),
    url: z.string(),
    description: z.string(),
    usageHint: z.string().nullable(),
    isActive: z.boolean(),
    createdAt: z.string(),
});
export const createSlashCommandInput = z.object({
    command: z
        .string()
        .trim()
        .toLowerCase()
        .regex(/^\/?[a-z0-9][a-z0-9_-]{0,30}$/, 'Csak kisbetű, szám, kötőjel és aluvonás.')
        .transform((value) => value.replace(/^\//, '')),
    url: z.string().url().max(2048),
    description: z.string().trim().max(200).default(''),
    usageHint: z.string().trim().max(100).optional(),
});
/** Mennyi ideig varunk a parancs azonnali valaszara. Utana `response_url` jon. */
export const SLASH_TIMEOUT_MS = 3000;
/** A kesleltetett valasz linkje ennyi ideig el. */
export const RESPONSE_URL_TTL_SECONDS = 30 * 60;
// ─── Kimeno esemenyek ─────────────────────────────────────────────────────────
export const outgoingEvents = [
    'message.created',
    'reaction.added',
    'channel.created',
    'member.joined',
    /**
     * Gombnyomas egy uzenet alatt.
     *
     * Szandekosan a MAR MEGLEVO kimeno webhook uton megy, nem sajat
     * visszahivasi cimen: igy nem kell egy masodik titok-kezelesi utat
     * epiteni es karbantartani ugyanarra a feladatra.
     */
    'interaction',
    /**
     * Telefonhivas-esemenyek a ProjectFlow-nak (docs/18-projectflow-hivas.md).
     * Csak a ProjectFlow-bol inditott hivasrol es annak visszahivasarol jonnek,
     * ujraprobalkozassal.
     */
    'call.ringing',
    'call.answered',
    'call.ended',
    /**
     * A kolléga hivasjegyzete ("Jegyzet a TT-be") egy ProjectFlow-hivasrol.
     * Mentesenkent ujra jon; a ProjectFlow-nal felulirja a korabbit.
     */
    'call.note',
    /**
     * Elkeszult egy ProjectFlow-hivas atirata. CSAK A LINK megy (Adam dontese
     * 2026-11-03): a feladatot tobben latjak, mint ahanyan a hivast, igy a
     * szoveget csak az nyitja meg, akinek az AVSlackben joga van hozza.
     */
    'call.transcript',
];
export const outgoingEventSchema = z.enum(outgoingEvents);
export const outgoingWebhookSchema = z.object({
    id: z.string(),
    name: z.string(),
    url: z.string(),
    events: z.array(outgoingEventSchema),
    channelId: z.string().nullable(),
    isActive: z.boolean(),
    failureCount: z.number(),
    lastError: z.string().nullable(),
    lastDeliveryAt: z.string().nullable(),
    createdAt: z.string(),
});
export const createOutgoingWebhookInput = z.object({
    name: z.string().trim().min(1).max(80),
    url: z.string().url().max(2048),
    events: z.array(outgoingEventSchema).min(1),
    channelId: z.string().optional(),
});
/**
 * Meglevo kimeno webhook modositasa - csak a megadott mezok valtoznak.
 *
 * Az alairo titok NEM valtozik: a fogado oldalon semmit nem kell atirni.
 * Az ures eseménylista itt megengedett, es azt jelenti, hogy MINDENT kap (a
 * kesobb bevezetett esemenyeket is) - igy mukodnek a regi, lista nelkuli sorok.
 */
export const updateOutgoingWebhookInput = z
    .object({
    name: z.string().trim().min(1).max(80),
    url: z.string().url().max(2048),
    events: z.array(outgoingEventSchema),
    isActive: z.boolean(),
})
    .partial();
/** Ennyi egymast koveto hiba utan magatol kikapcsol a webhook. */
export const OUTGOING_MAX_FAILURES = 20;
// ─── Audit naplo ──────────────────────────────────────────────────────────────
export const auditEntrySchema = z.object({
    id: z.string(),
    actorId: z.string().nullable(),
    actorName: z.string().nullable(),
    /** Melyik ceget erinti. `null`: kiszolgalo-szintu vagy rendszer-esemeny. */
    teamId: z.string().nullable(),
    teamName: z.string().nullable(),
    action: z.string(),
    targetType: z.string().nullable(),
    targetId: z.string().nullable(),
    meta: z.record(z.string(), z.unknown()).nullable(),
    ip: z.string().nullable(),
    createdAt: z.string(),
});
/** Az audit naplo emberi olvasatra szant cimkei. */
export const AUDIT_LABELS = {
    'token.created': 'Token létrehozva',
    'projectflow.tasks_created': 'Feladat a ProjectFlow-ba',
    'token.revoked': 'Token visszavonva',
    'user.invited': 'Kolléga felvéve',
    'user.password_reset': 'Új ideiglenes jelszó',
    'user.role_changed': 'Szerepkör módosítva',
    'user.directory_changed': 'Névjegyadatok módosítva',
    'user.deactivated': 'Fiók letiltva',
    'user.reactivated': 'Fiók visszaengedve',
    'user.sessions_revoked': 'Kiléptetve minden eszközről',
    'user.team_changed': 'Másik céghez helyezve',
    'channel.archived': 'Csatorna archiválva',
    'channel.deleted': 'Csatorna törölve',
    'emoji.added': 'Emoji hozzáadva',
    'emoji.removed': 'Emoji törölve',
    'slash.created': 'Slash parancs létrehozva',
    'slash.removed': 'Slash parancs törölve',
    'webhook.created': 'Kimenő webhook létrehozva',
    'webhook.updated': 'Kimenő webhook módosítva',
    'webhook.removed': 'Kimenő webhook törölve',
    'retention.changed': 'Adatmegőrzés módosítva',
    'retention.applied': 'Adatmegőrzés végrehajtva',
    'export.created': 'Export készült',
    'service.updated': 'Vevőszolgálati beállítás módosítva',
};
// ─── Adatmegorzes ─────────────────────────────────────────────────────────────
export const retentionPolicySchema = z.object({
    channelId: z.string().nullable(),
    channelName: z.string().nullable(),
    days: z.number(),
    fileDays: z.number(),
    updatedAt: z.string(),
});
export const updateRetentionInput = z.object({
    channelId: z.string().nullable().optional(),
    /** 0 = nincs korlat. */
    days: z.number().int().min(0).max(3650),
    fileDays: z.number().int().min(0).max(3650),
});
// ─── Egyedi emoji ─────────────────────────────────────────────────────────────
export const customEmojiSchema = z.object({
    id: z.string(),
    name: z.string(),
    url: z.string(),
    createdAt: z.string(),
});
export const EMOJI_NAME_RE = /^[a-z0-9][a-z0-9_-]{0,30}$/;
// ─── Korlatozas ───────────────────────────────────────────────────────────────
/** Alapertelmezett keresszam percenkent, tokenenkent. */
export const RATE_LIMIT_PER_MINUTE = 60;
// ─── Hivasinditas kulso rendszerbol (ProjectFlow) ──────────────────────────────
/** `POST /api/calls` - a ProjectFlow egy feladatbol hivast ker egy kolléga neveben. */
export const startCallInput = z.object({
    userEmail: z.string().trim().min(3).max(320),
    to: z.string().trim().min(3).max(40),
    /** A ProjectFlow sajat hivasnaplo-azonositoja - minden esemenyben visszakapja. */
    callId: z.string().trim().min(1).max(200),
    taskId: z.string().trim().min(1).max(200),
    // Csak http(s): a cim linkkent jelenik meg, egy `javascript:` cim ott kodot futtatna.
    taskUrl: z
        .string()
        .url()
        .max(2048)
        .refine((url) => /^https?:\/\//i.test(url), 'Csak http(s) cím lehet.'),
    // A ProjectFlow `null`-t is kuldhet - az ugyanaz, mint a hianyzo mezo.
    taskTitle: z.string().trim().max(300).nullish(),
    contactName: z.string().trim().max(200).nullish(),
    lineId: z.string().trim().max(100).nullish(),
});
/** A `call.ended` vegeredmenye, ahogy a ProjectFlow-val megallapodtunk. */
export const callResults = [
    'completed',
    'no_answer',
    'busy',
    'rejected',
    'user_declined',
    'user_unavailable',
    'failed',
];
/** Ennyi ideig csorog a kolléganal a ProjectFlow-hivas, mielott `user_unavailable` lesz. */
export const PF_CALL_USER_RING_SECONDS = 30;
/** Ennyi napig parositjuk a visszahivast a feladathoz. */
export const PF_CALL_PAIRING_DAYS = 30;
//# sourceMappingURL=integration.js.map